import React from 'react'

// tremor 
import { Flex, Title } from "@tremor/react";

// bootstrap
import { Button } from "react-bootstrap";

// custom components
import { CustomSpinner } from "_atoms";

// redux
import { useSelector, useDispatch } from "react-redux";
import { selectDeleteAirportLocationsStatus, selectSelectedAirportLocation, deleteAirportLocation, setSelectedAirportLocation } from "_redux/slices/timeline/timeline-areas";

//styles
import { Colors, Spacing } from "_styles";

const DeleteAirportLocation = ({ closeModal }) => {

    //#region redux
    const dispatch = useDispatch();

    const deleteAirportLocationsStatus = useSelector(selectDeleteAirportLocationsStatus);         // delete airport location status
    const selectedAirportLocation = useSelector(selectSelectedAirportLocation)                    // selected airport location to delete
    //#endregion

    //#region functions
    const confirmDelete = () => {
        const data = { id: selectedAirportLocation._id }
        dispatch(deleteAirportLocation(data))
        dispatch(setSelectedAirportLocation(null));
    }
    //#endregion

    return (
        <div >
            <div>
                <p style={{ margin: 0, padding: 0, fontSize: "18px", height: "24px" }}>
                    <span style={{ fontWeight: "bold" }}>{selectedAirportLocation?.title}</span>&nbsp;will be deleted. Are you sure?
                </p>
            </div>
            <div style={{ marginTop: Spacing.SCALE_22 }}>
                <Flex>
                    <Button variant={"outline-primary"} onClick={confirmDelete}>{deleteAirportLocationsStatus === 'loading' ? <CustomSpinner /> : "Delete"}</Button>
                    <Button variant={"outline-danger"} onClick={closeModal}>Cancel</Button>
                </Flex>
            </div>
        </div>
    )
}

export default DeleteAirportLocation;
